import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import {
  BooleanStatusChipField,
  EmbeddedFunctionField,
  FunctionField,
} from 'shared/react-admin/Fields';
import { Company } from 'types/embedded/company';

export const MethodsShowChipFields: React.FC = () => {
  const translate = useTypedTranslate();
  const { hasResourceAccess } = usePermissions();

  return (
    <Stack direction="row" flexWrap="wrap" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: Company) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <FunctionField
        render={({ name }: Company) => (
          <Chip label={`${translate('app.table.name')}: ${name}`} size="small" />
        )}
      />
      {hasResourceAccess('method_types') && (
        <EmbeddedFunctionField
          render={(name) => (
            <Chip label={`${translate('app.methods.type')}: ${name}`} size="small" />
          )}
          sourceField="methodType.name"
        />
      )}
      <BooleanStatusChipField
        disabledLabel={translate('app.methods.inactive')}
        enabledLabel={translate('app.methods.active')}
        source="active"
      />
    </Stack>
  );
};
